"use client";

import Pagination from "@/app/components/pagination";
import { usePagination } from "react-instantsearch";

export default function AlgoliaCustomPagination({ onPageChange }: AlgoliaCustomPaginationProps) {
  const { currentRefinement, nbPages, nbHits, refine } = usePagination();

  if (nbHits === 0 || nbPages <= 1) return null;

  const handlePageChange = (page: number) => {
    refine(page - 1);
    onPageChange?.();
  };

  return (
    <Pagination
      currentPage={currentRefinement + 1}
      totalPages={nbPages}
      totalResults={nbHits}
      onPageChange={handlePageChange}
    />
  );
}

type AlgoliaCustomPaginationProps = {
  onPageChange?: () => void;
};
